export default __webpack_public_path__ + "static/media/10.39a291b4.png";